package com.exura.ui.modifiers

enum class ShadeBorder {
    TOP, LEFT, BOTTOM, RIGHT
}
